import React, { useState, useEffect, useRef } from "react";
import { styled } from '@material-ui/core/styles';
import { API } from "aws-amplify";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import RunIcon from '@material-ui/icons/PlayCircleFilled';
import CancelIcon from '@material-ui/icons/Cancel';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

export default function TabParse(props) {
    const { project, docRef, updateConfig, config, updateSteps, disabled } = props;

    //console.log(config);

    const [promptUser, setPromptUser] = useState(config && config.options && config.options.promptUser ? config.options.promptUser : "");
    const [promptSys, setPromptSys] = useState(config && config.options && config.options.promptSys ? config.options.promptSys : "");
    const [isUploading, setIsUploading] = useState("");
    const [jobId, setJobId] = useState(null);
    const [copied, setCopied] = useState(false);
    const [resultsData, setResultsData] = useState("");
    const [isRunning, setIsRunning] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
    //const [startTime, setStartTime] = useState(0);
    const [selectedModel, setSelectedModel] = useState('gpt-4.1-mini');
    const [resOpen, setResOpen] = useState(false);

    const [resultsTitle, setResultsTitle] = useState('');
    const [resultsStatus, setResultsStatus] = useState('');

    const resultsStatusRef = useRef(resultsStatus);
    const startTimeRef = useRef(0);

    /*
    const models = [
        { value: 'gpt-4.1-mini', label: 'GPT-4.1 Mini' },
        { value: 'gpt-4.1', label: 'GPT-4.1' },
        { value: 'gpt-4o', label: 'gpt-4o' },
        { value: 'gpt-3.5-turbo', label: 'GPT-3.5 Turbo' }
    ];
    */

    const ExpandMore = styled((props) => {
        const { expand, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand }) => ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));

    const run = async (e) => {
        e.preventDefault();
        resetResults();
        saveConfig();
        //setStartTime(Date.now());
        startTimeRef.current = Date.now();
        setResultsData('Parsing...')
        setIsRunning(true);
        updateSteps(0, false);
        setResOpen(true);

        runParser();
    }
    const cancel = async (e) => {
        e.preventDefault();
        setResultsData('Cancelling ...');
        setIsCancelling(true);
    }

    function resetResults() {
        setResultsTitle('');
        setResultsData('');
        setResOpen(false);
    }


    const saveConfig = async () => {
        const body = { type: "parse", values: { options: { promptSys: promptSys, promptUser: promptUser } } };
        await updateConfig(body);
    }

    const copyToClipboard = (e) => {
        navigator.clipboard.writeText(resultsData)
            .then(() => {
                console.log("Text copied to clipboard!");
                setCopied(true);
                setTimeout(() => setCopied(false), 1500); // hide after 2 sec
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    }


    useEffect(() => {
        let pollingInterval;
        if (isRunning) {
            pollingInterval = setInterval(updateResultsStatus, 300); // Check every 5 seconds
        }
        try {
            return () => {
                clearInterval(pollingInterval);
            } // Clear polling on unmount or when parsing stops
        } catch (e) {
            // do nowt
        }
    }, [isRunning]); //

    const updateResultsStatus = () => {
        const timeDiff = (Date.now() - startTimeRef.current) / 1000;
        setResultsStatus(timeDiff)

    }


    /////// Step Specific Stuff /////////////////////////////////

    async function runParser() {
        console.log(docRef.current);
        parseDoc({ type: "bufferParse", doc: docRef.current }) // project id is doc pk
            .then(resultParse => {
                console.log("Got data:", resultParse);
                const data = typeof resultParse.data === "string" ? JSON.parse(resultParse.data) : resultParse.data;
                const { id, status } = data;
                setJobId(id);
            }).catch(err => {
                setIsRunning(false);
                setResultsData("parsing failed: " + err.message);
                console.log('err');
                console.error('Error uploading file:', err);
            });
    }

    function parseDoc(body) {
        console.log(body);
        return API.post("findigai", "/parse", {
            body: body
        });
    }

    function synthesizeBlocks(body) {
        console.log(body);
        return API.post("findigai", "/synthesize", {
            body: body
        });
    }

    


    useEffect(() => {
        //console.log("polling");
        let pollingInterval;
        if (isRunning) {
            pollingInterval = setInterval(pollParsingStatus, 5000); // Check every 5 seconds
        }
        try {
            return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
        } catch (e) {
            // do nowt
        }

    }, [isRunning, jobId]);


    const pollParsingStatus = async () => {
        if (isRunning) {
            if (isCancelling) {
                setIsRunning(false);
                setResultsData("Cancelled ok!");
                setIsCancelling(false);
                // should request a cancellation to llamaparse here
            } else {
                try {
                    if (!jobId) return;
                    const resultJob = await parseDoc({ type: "job", id: jobId, doc: docRef.current });
                    const { status } = resultJob.data;
                    //console.log(status,status !== "PENDING",status === "SUCCESS")
                    //resultsData += " " + status
                    //setResultsData(resultsData);
                    if (status !== "PENDING") { //PENDING, SUCCESS, ERROR, PARTIAL_SUCCESS, CANCELLED
                        if (status === "SUCCESS") {
                            //updateSteps(0, true);
                            //setResultsData("parsing completed ok!");
                            buildBlocks();
                        } else {
                            updateSteps(-1, false);
                            setResultsData("parsing failed: " + status);
                            console.log("DOC PARSING FAILED: ", status)
                            setIsRunning(false);
                        };
                        //setIsRunning(false);
                    }
                } catch (error) {
                    updateSteps(-1, false);
                    setIsRunning(false);
                    setResultsData("parsing failed: " + error.message);
                    console.error('Error checking parsing status:', error);
                }
            }
        }
    };

    async function buildBlocks() {
        setResultsData("synthesizing blocks...");
        const result = await synthesizeBlocks({ type: "blocks", prjid: docRef.current.pk, docid: docRef.current.itemId });
        console.log(result);
        updateSteps(0, true);
        setResultsData("parsing completed ok!");
        setIsRunning(false);
    };



    return (

        <>
            {/* RESULTS SECTION */}

            <Box mt={1}>
                <Paper style={{ backgroundColor: "#e8f6f3" }}>
                    <Box p={1} >
                        <Box display="flex" alignItems='center' flexDirection="row" >
                            <Box mx={1} pb={1}>
                                <Tooltip title="Run">
                                    <IconButton
                                        onClick={run}
                                        disabled={isRunning || !docRef.current || disabled}
                                        size="small"
                                    >
                                        <RunIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box mx={1} pb={1}>
                                <Tooltip title="Clear results">
                                    <IconButton
                                        onClick={cancel}
                                        disabled={!isRunning || disabled}
                                        size="small"
                                    >
                                        <CancelIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                            <Box pv={0} >
                                <Typography variant="body2" style={{ color: 'green', fontSize: '0.8rem' }}>
                                    &nbsp;&nbsp;&nbsp;{Number(resultsStatus).toFixed(2) + " seconds"}
                                </Typography>
                            </Box>
                            <Box sx={{ flexGrow: 1 }} ></Box>
                            <Box mx={1} pb={1}>
                                <Tooltip title="Copy results to clipboard">
                                    <IconButton
                                        onClick={copyToClipboard}
                                        disabled={disabled}
                                        size="small"
                                    >
                                        <FileCopyIcon />
                                    </IconButton>
                                </Tooltip>
                                {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                            </Box>
                            <ExpandMore
                                color="primary"
                                expand={resOpen}
                                onClick={() => { setResOpen(!resOpen) }}
                                aria-expanded={resOpen}
                                aria-label="show results"
                                size="small"
                                id="resOpen">
                                <ExpandMoreIcon />
                            </ExpandMore>
                        </Box>
                        <Collapse in={resOpen} timeout="auto" unmountOnExit>
                            <>
                                <h6><u>{resultsTitle}</u></h6>
                                <Box m={2}>
                                    <Paper>
                                        <Box m={1} py={1}>
                                            <div style={{ whiteSpace: 'pre-wrap' }}>{resultsData}</div>
                                        </Box>
                                    </Paper>
                                </Box>
                            </>
                        </Collapse>
                    </Box>

                </Paper>
            </Box>

            {/* OPTIONS SECTION */}

            <Box mt={1}>
                <Paper style={{ backgroundColor: "#f2f2ff" }}>
                    <Box p={2}>
                        <Box pv={2} pl={0.5}>
                            <h6>System prompt (Append)</h6>
                        </Box>
                        <TextareaAutosize
                            minRows={1}
                            disabled={isRunning || disabled}
                            placeholder="<empty>"
                            value={promptSys}
                            onChange={(e) => setPromptSys(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                            }}
                        />
                        <Box pt={3} pb={0} pl={0.5} >
                            <h6>User prompt </h6>
                        </Box>
                        <TextareaAutosize
                            minRows={1}
                            disabled={isRunning || disabled}
                            placeholder="<empty>"
                            value={promptUser}
                            onChange={(e) => setPromptUser(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                border: '1px solid #ccc',
                                resize: 'vertical',
                            }}
                        />
                    </Box>
                </Paper>
            </Box>
        </>
    )
};